<header class="
  top-0
  lef-0
  w-full
  z-40
  bg-gray-900
  shadow
  fixed
  border-b
  border-gray-200
">
   <div class="container mx-auto px-6 h-16 flex justify-between items-center">
    <span class="font-semibold text-xl text-white tracking-tight">
      Book Review
    </span>
  </div>
</header>